import { Component, Input, OnInit, inject } from "@angular/core";
import { RosterRunHistory } from "@app/models/rest/roster/roster-run-history";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { RosterRunHistoryEntryStore } from "@app/services/store/roster/roster-run-history-entry-store";
import { RosterRunHistoryEntry } from "@app/models/rest/roster/roster-run-history-entry";
import moment from "moment";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { GridComponent } from "../../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";

function renderShiftText(record) {
  console.log("rendering shift text", record);
  let effectiveDate = record.get("effectiveDate");
  let shift = record.get("shift");
  if (!shift || !effectiveDate) {
    return "No data";
  }
  let start = moment(effectiveDate)
    .hour(shift.startOffsetHour)
    .minute(shift.startOffsetMinute);
  let end = moment(start).add(shift.duration, "minutes");
  return `${start.format("HH:mm")} - ${end.format("HH:mm")}`;
}

@Component({
  selector: "app-run-history-entry-grid",
  templateUrl: "./run-history-entry-grid.component.html",
  styleUrls: ["./run-history-entry-grid.component.css"],
  imports: [GridComponent, MatPaginator]
})
export class RunHistoryEntryGridComponent
  extends BaseDataTablePageDirective<RosterRunHistoryEntry>
  implements OnInit
{
  rosterRunHistoryEntryStore: RosterRunHistoryEntryStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;

  @Input()
  runHistory: RosterRunHistory;
  @Input()
  public columns: object[] = [
    {
      field: "rosterAssignment.resource.name",
      text: "Resource",
      flex: 1,
      editor: false,
      sortable: true
    },
    {
      field: "rosterAssignment.subDivision.name",
      text: "Division",
      flex: 1,
      editor: false,
      sortable: true
    },
    {
      field: "effectiveDate",
      text: "Shift Date",
      flex: 1,
      format: "DD/MM/YYYY",
      type: "date",
      editor: false
    },
    {
      type: "template",
      text: "Shift Time",
      flex: 1,
      template: ({ record }) => renderShiftText(record),
      editor: false
    },
    {
      field: "status",
      text: "Outcome",
      flex: 1,
      editor: false
    }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const rosterRunHistoryEntryStore = inject(RosterRunHistoryEntryStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      rosterRunHistoryEntryStore,
      store,
      dialog,
      "RosterRunHistoryEntry",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.rosterRunHistoryEntryStore = rosterRunHistoryEntryStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.runHistory) {
      this.gridStore.parentField = "rosterRunHistory.id";
      this.gridStore.parentId = this.runHistory.id;
      this.gridStore.autoCommit = false;
      this.gridStore.sort("effectiveDate", false);
      this.gridStore.load({});
    }
  }

  addRow() {
    this.gridStore.insert(0, {
      code: "",
      description: "",
      scoreWeight: 1
    });
  }
}
